/**
 * Generated from ch5_p04.fla
 */
export function ch5_p04(this: Ich5_p04) {
	const bg = this.bg;
	ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_bg.call(this.bg);
	bg.x = 1000;
	bg.y = 384;
	bg.width = 1789.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const hollyBack = this.hollyBack;
	ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_hollyback.call(this.hollyBack);
	hollyBack.x = 533.75;
	hollyBack.y = 448.75;
	hollyBack.width = 194.50;
	hollyBack.height = 612.50;
	hollyBack.alpha = 1.00;
	if (hollyBack.onLayout) hollyBack.onLayout();
	const horse = this.horse;
	ch5_p04_hh_ch5_72dpi_p0405psdAssethorse.call(this.horse);
	horse.x = 992.25;
	horse.y = 731;
	horse.width = 904.50;
	horse.height = 623.50;
	horse.alpha = 1.00;
	if (horse.onLayout) horse.onLayout();
	const hollyFront = this.hollyFront;
	ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_hollyfront.call(this.hollyFront);
	hollyFront.x = 571.75;
	hollyFront.y = 352.5;
	hollyFront.width = 122.50;
	hollyFront.height = 47.00;
	hollyFront.alpha = 1.00;
	if (hollyFront.onLayout) hollyFront.onLayout();
	const apple = this.apple;
	ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_apple.call(this.apple);
	apple.x = 1187.5;
	apple.y = 80.5;
	apple.width = 93.00;
	apple.height = 104.00;
	apple.alpha = 1.00;
	if (apple.onLayout) apple.onLayout();
	const brush = this.brush;
	ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_brush.call(this.brush);
	brush.x = 1351.5;
	brush.y = 94;
	brush.width = 101.00;
	brush.height = 69.00;
	brush.alpha = 1.00;
	if (brush.onLayout) brush.onLayout();
	const rope = this.rope;
	ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlerope.call(this.rope);
	rope.x = 1389;
	rope.y = 251.5;
	rope.width = 77.00;
	rope.height = 139.00;
	rope.alpha = 1.00;
	if (rope.onLayout) rope.onLayout();
	const blanket = this.blanket;
	ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlehangingblanket.call(this.blanket);
	blanket.x = 1346;
	blanket.y = 349.25;
	blanket.width = 88.00;
	blanket.height = 356.50;
	blanket.alpha = 1.00;
	if (blanket.onLayout) blanket.onLayout();
	const saddle = this.saddle;
	ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlehangingsaddle.call(this.saddle);
	saddle.x = 1378.75;
	saddle.y = 393;
	saddle.width = 175.50;
	saddle.height = 330.00;
	saddle.alpha = 1.00;
	if (saddle.onLayout) saddle.onLayout();
	const frameRight = this.frameRight;
	ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const appleTarget = this.appleTarget;
	ch5_p04_appleTarget.call(this.appleTarget);
	appleTarget.x = 605;
	appleTarget.y = 232.95;
	appleTarget.width = 238.00;
	appleTarget.height = 238.00;
	if (appleTarget.onLayout) appleTarget.onLayout();
	const saddleTarget = this.saddleTarget;
	ch5_p04_saddleTarget.call(this.saddleTarget);
	saddleTarget.x = 947.95;
	saddleTarget.y = 305;
	saddleTarget.width = 242.00;
	saddleTarget.height = 242.00;
	if (saddleTarget.onLayout) saddleTarget.onLayout();
	const hairBrushTarget = this.hairBrushTarget;
	ch5_p04_hairBrushTarget.call(this.hairBrushTarget);
	hairBrushTarget.x = 724;
	hairBrushTarget.y = 232.95;
	hairBrushTarget.width = 240.00;
	hairBrushTarget.height = 240.00;
	if (hairBrushTarget.onLayout) hairBrushTarget.onLayout();
	const tailBrushTarget = this.tailBrushTarget;
	ch5_p04_tailBrushTarget.call(this.tailBrushTarget);
	tailBrushTarget.x = 1257;
	tailBrushTarget.y = 415;
	tailBrushTarget.width = 400.00;
	tailBrushTarget.height = 400.00;
	if (tailBrushTarget.onLayout) tailBrushTarget.onLayout();
	return this;
}
function ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_bg(this: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p04_bg", 0.559, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_hollyback(this: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_hollyback) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p04_hollyback", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p04_hh_ch5_72dpi_p0405psdAssethorse(this: Ich5_p04_hh_ch5_72dpi_p0405psdAssethorse) {
	if (this.setLayoutTexture) this.setLayoutTexture("horse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_hollyfront(this: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_hollyfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p04_hollyfront", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_apple(this: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_apple) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p04_apple", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_brush(this: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_brush) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p04_brush", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlerope(this: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlerope) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p04_saddlerope", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlehangingblanket(this: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlehangingblanket) {
	if (this.setLayoutTexture) this.setLayoutTexture("blanket", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlehangingsaddle(this: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlehangingsaddle) {
	if (this.setLayoutTexture) this.setLayoutTexture("saddle", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_wcframeRframe(this: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_wcframeLframe(this: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p04_appleTarget(this: Ich5_p04_appleTarget) {
	return this;
}
function ch5_p04_saddleTarget(this: Ich5_p04_saddleTarget) {
	return this;
}
function ch5_p04_hairBrushTarget(this: Ich5_p04_hairBrushTarget) {
	return this;
}
function ch5_p04_tailBrushTarget(this: Ich5_p04_tailBrushTarget) {
	return this;
}
interface Ich5_p04Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich5_p04Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich5_p04Sprite extends Ich5_p04Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich5_p04Text extends Ich5_p04Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich5_p04Polygon extends Array<number> {
}
interface Ich5_p04 {
	readonly bg: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_bg;
	readonly hollyBack: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_hollyback;
	readonly horse: Ich5_p04_hh_ch5_72dpi_p0405psdAssethorse;
	readonly hollyFront: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_hollyfront;
	readonly apple: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_apple;
	readonly brush: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_brush;
	readonly rope: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlerope;
	readonly blanket: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlehangingblanket;
	readonly saddle: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlehangingsaddle;
	readonly frameRight: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_wcframeRframe;
	readonly frameLeft: Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_wcframeLframe;
	readonly appleTarget: Ich5_p04_appleTarget;
	readonly saddleTarget: Ich5_p04_saddleTarget;
	readonly hairBrushTarget: Ich5_p04_hairBrushTarget;
	readonly tailBrushTarget: Ich5_p04_tailBrushTarget;
}
interface Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_bg extends Ich5_p04Sprite {
}
interface Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_hollyback extends Ich5_p04Sprite {
}
interface Ich5_p04_hh_ch5_72dpi_p0405psdAssethorse extends Ich5_p04Sprite {
}
interface Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_hollyfront extends Ich5_p04Sprite {
}
interface Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_apple extends Ich5_p04Sprite {
}
interface Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_brush extends Ich5_p04Sprite {
}
interface Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlerope extends Ich5_p04Sprite {
}
interface Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlehangingblanket extends Ich5_p04Sprite {
}
interface Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_saddlehangingsaddle extends Ich5_p04Sprite {
}
interface Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_wcframeRframe extends Ich5_p04Sprite {
}
interface Ich5_p04_hh_ch5_72dpi_p0405psdAssetchp5_p04_wcframeLframe extends Ich5_p04Sprite {
}
interface Ich5_p04_appleTarget extends Ich5_p04Container {
}
interface Ich5_p04_saddleTarget extends Ich5_p04Container {
}
interface Ich5_p04_hairBrushTarget extends Ich5_p04Container {
}
interface Ich5_p04_tailBrushTarget extends Ich5_p04Container {
}
